import gql from "graphql-tag";

export const createBatchEvent = gql`
  mutation CreateBatchEvent($data: BatchEventCreateInput!) {
    createBatchEvent(data: $data) {
      id
    }
  }
`;
